import { MethodDescription } from '../method-description';

export const RestorePasswordMethodDescription = new MethodDescription();

RestorePasswordMethodDescription.name = 'restorePassword';
RestorePasswordMethodDescription.fields = [
	'email',
];
RestorePasswordMethodDescription.usesToken = false;
